// pages/Unauthorized.js
import { ShieldX, Home, Mail, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Glass card effect */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 p-8 md:p-12 text-center">
          
          {/* Icon with animated background */}
          <div className="relative inline-flex mb-6">
            <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-orange-500 rounded-full blur-lg opacity-50 animate-pulse"></div>
            <div className="relative bg-gradient-to-r from-red-500 to-orange-600 p-5 rounded-full">
              <ShieldX className="w-12 h-12 text-white" />
            </div>
          </div>

          {/* Title with gradient */}
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-red-600 to-orange-600 bg-clip-text text-transparent">
            Access Denied
          </h1>

          {/* Status code */}
          <div className="mb-6">
            <span className="inline-flex items-center px-4 py-2 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400 rounded-full text-sm font-semibold">
              Error 403 - Forbidden
            </span>
          </div>

          {/* Description */}
          <p className="text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
            You don't have permission to access this resource. Please contact the Research and Development team for access authorization.
          </p>

          {/* Action buttons */}
          <div className="space-y-3">
            <button
              onClick={() => navigate(-1)}
              className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-yellow-500 to-amber-600 text-white font-semibold rounded-lg hover:from-yellow-600 hover:to-amber-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-[1.02]"
            >
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </button>

            <button
              onClick={() => navigate('/home')}
              className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-white dark:bg-gray-700 text-gray-800 dark:text-white font-semibold rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600 transition-all duration-300 border border-gray-200 dark:border-gray-600"
            >
              <Home className="w-5 h-5" />
              Return Home
            </button>

            <a
              href="mailto:research@uas.com.ph?subject=Access Request"
              className="w-full flex items-center justify-center gap-2 px-6 py-3 text-gray-600 dark:text-gray-400 font-medium hover:text-gray-800 dark:hover:text-gray-200 transition-colors"
            >
              <Mail className="w-4 h-4" />
              Contact R&D Team
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;